import React from "react";
import iconDefault from "../../img/icons-ext-file/iconDefault.png"

export default function FileDefault() {
    return (
        <img src={iconDefault} alt="" />
    );
}